import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { useSnackbar } from '@lyearn/ui';
import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';
import { UpdateActionItemInput } from '@/types/schema';

import { useUpdateActionItemMutation } from '../graphql/mutations/generated/updateActionItem';

const ASSIGNEE_ERROR = 'not present at external source';

const useUpdateActionItem = () => {
  const { t } = useTranslation();
  const { showErrorSnackbar } = useSnackbar();
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();
  const [{ fetching }, execute] = useUpdateActionItemMutation();

  const updateActionItem = useCallback(
    (variables: { data: UpdateActionItemInput }) =>
      execute(variables).then((response) => {
        if (response.error) {
          if (response.error.message.includes(ASSIGNEE_ERROR)) {
            showErrorSnackbar({ message: t('Task:JiraAssigneeError') });
          } else {
            showDefaultErrorSnackbar();
          }
        }

        return response;
      }),
    [execute, showDefaultErrorSnackbar, showErrorSnackbar, t],
  );

  return { fetching, updateActionItem };
};

export default useUpdateActionItem;
